<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/t82vca/tc-custom/9781512404333.jpg?1703877196242" alt="This image is the cover for the book Buster Posey, Amazing Athletes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Buster Posey, Amazing Athletes
      </h1>
      <p class="bookDescription body article font2">
        <p>San Francisco Giants catcher Buster Posey has done it all in his short Major League Baseball career. In 2010, he was named National League (NL) Rookie of the Year. In 2012, Buster won the NL batting title and was named NL Most Valuable Player. But Buster has done more than just collect individual baseball awards. The Giants have won the World Series three times with Buster behind the plate (2010, 2012, and 2014). Learn more about one of baseball's most successful players.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jon M Fishman
      </h2>
      
      <p class="authorDescription body article"><B>Jon M. Fishman</B> is an editor, author, and sports fan. He lives in Wisconsin with his wife and three dogs.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Lerner Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e88fe0c